/**
 * Whether a device output is energized. "Output" rather than "valve" because a port may drive a
 * latching relay for a pump rather than a solenoid.
 */
export enum OutputPosition {
    /** De-energized: valve closed or pump stopped. */
    OFF = 0,
    /** Energized: valve open or pump running. */
    ON = 1,
}

/** The inclusive range of legal stored values, for the sensor element's `legalConvertedRange`. */
export const OUTPUT_POSITION_RANGE: [number, number] = [OutputPosition.OFF, OutputPosition.ON];
